import CreatePayment from "./CreatePayment";
import CalculateDesiredRating from "../Shared/CalculateDesiredRating";
import { Field, Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Accordion } from "react-bootstrap";
import MenuLink from "../Shared/MenuLink";
import useScrollWatcher from "../Shared/ScrollWatcher";
import { useTranslation } from "react-i18next";
import AdvantagesSection from "./AdvantagesSection";
import ContactForm from "../Shared/ContactForm";
import ClientsMarquee from "../Optimization/ClientsMarquee";
import "../laptop.css";
function Home() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [calcResult, setCalcResult] = useState(null);
  const advantageSlides = t("advantageSlides", { returnObjects: true });
  const services = t("services", { returnObjects: true });
  const faqs = t("faqs", { returnObjects: true });

  const [promoRef, isPromoVisible] = useScrollWatcher();
  const [calcRef, isCalcVisible] = useScrollWatcher();
  const [platformsRef, isPlatformsVisible] = useScrollWatcher();
  const [opportunitiesRef, isOpportunitiesVisible] = useScrollWatcher();
  const [optionsRef, isOptionsVisible] = useScrollWatcher();
  const [stepsRef, isStepsVisible] = useScrollWatcher();

  const [tariffsRef, isTariffsVisible] = useScrollWatcher();
  const [defTariffsRef, isDefTariffsVisible] = useScrollWatcher();
  const [faqRef, isFaqVisible] = useScrollWatcher();
  const [servicesRef, isServicesVisible] = useScrollWatcher();

  const [defPlanSelected, setDefPlanSelected] = useState(2);
  const m = [3, 6, 12];
  const tariffsBody = (
    <div className="tariffs__body tariffs__body-ua">
      <div className="item-tariffs item-tariffs--def item-tariffs--super">
        <div
          className="item-tariffs__head"
          style={{ marginBottom: i18n.language === "pl" && 45 }}
        >
          <h3 className="item-tariffs__title">DEFENDER</h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price" style={{ color: "white" }}>
              <span>{t(`tariffs.defender.${m[defPlanSelected]}mo`)}</span>{" "}
              {t("seo.package.currency")}/{t("seo.package.month")}
            </p>
            <p className="item-tariffs__text">
              {t(`tariffs.defender.${m[defPlanSelected]}mo`) *
                m[defPlanSelected]}{" "}
              {t("tariffs.priceFor")} {m[defPlanSelected]}{" "}
              {m[defPlanSelected] == 3
                ? t("seo.package.months")
                : t("seo.package.manyMonths")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
            <div
              className="choose_container"
              style={{
                marginTop: i18n.language === "pl" ? -15 : 0,
                borderRadius: "15px",
              }}
            >
              <div className="button_wrapper">
                <button
                  className={`basic_choose_button ${defPlanSelected === 0 ? "selected" : ""}`}
                  onClick={() => setDefPlanSelected(0)}
                >
                  3 {t("seo.package.month")}
                </button>
                <button
                  className={`basic_choose_button ${defPlanSelected === 1 ? "selected" : ""}`}
                  onClick={() => setDefPlanSelected(1)}
                >
                  6 {t("seo.package.month")}
                </button>
                <button
                  className={`basic_choose_button ${defPlanSelected === 2 ? "selected" : ""}`}
                  onClick={() => setDefPlanSelected(2)}
                >
                  12 {t("seo.package.month")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.features.qr_filter")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.instant_email_alert")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.custom_review_page")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.review_stats")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.employee_control")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.strategy_selection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.pos_design")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.surveying")}
            </li>
          </ul>

          <CreatePayment
            amount={7860}
            currency={"UAH"}
            description={'Пакет "Defender"'}
          />
        </div>
      </div>
      <div className="item-tariffs item-tariffs--basic">
        <div className={"item-tariffs__bonus-cover"}></div>
        <div className={"item-tariffs__bonus"}>
          <p>+5 {t("tariffs.bonus_text")}</p>
        </div>
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">
            START {t("tariffs.packageCounts.start")}
          </h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price">
              <span>{t("tariffs.start")}</span> {t("tariffs.perReview")}
            </p>
            <p className="item-tariffs__text">
              {t("tariffs.start") * t("tariffs.packageCounts.start")}{" "}
              {t("tariffs.priceFor")} {t("tariffs.packageCounts.start")}{" "}
              {t("tariffs.reviews")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.features.guaranteed_reviews", {
                count: t("tariffs.packageCounts.start"),
              })}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.rating_boost")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.message_development")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.review_stats")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.competitor_analysis")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.map_point_analysis")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.crm_integration")}
            </li>
          </ul>

          <CreatePayment
            amount={2950}
            currency={"UAH"}
            description={'Пакет "Start 10"'}
          />
        </div>
      </div>
      <div className="tariffs__item item-tariffs item-tariffs--popular">
        <div className={"item-tariffs__bonus-cover"}></div>
        <div className={"item-tariffs__bonus"}>
          <p>+10 {t("tariffs.bonus_text")}</p>
        </div>
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">
            BASIC {t("tariffs.packageCounts.basic")}
          </h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price">
              <span>{t("tariffs.basic")}</span> {t("tariffs.perReview")}
            </p>
            <p className="item-tariffs__text">
              {t("tariffs.basic") * t("tariffs.packageCounts.basic")}{" "}
              {t("tariffs.priceFor")} {t("tariffs.packageCounts.basic")}{" "}
              {t("tariffs.reviews")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.features.guaranteed_reviews", {
                count: t("tariffs.packageCounts.basic"),
              })}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.rating_boost")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.message_development")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.review_stats")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.competitor_analysis")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.map_point_analysis")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.crm_integration")}
            </li>
          </ul>
          <CreatePayment
            amount={189 * 50}
            currency={"UAH"}
            description={'Пакет "Basic 50"'}
          />
        </div>
      </div>
      <div className="tariffs__item item-tariffs item-tariffs--professional">
        <div className={"item-tariffs__bonus-cover"}></div>
        <div className={"item-tariffs__bonus"}>
          <p>+20 {t("tariffs.bonus_text")}</p>
        </div>
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">
            PROFESSIONAL {t("tariffs.packageCounts.professional")}
          </h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price">
              <span>{t("tariffs.pro")}</span> {t("tariffs.perReview")}
            </p>
            <p className="item-tariffs__text">
              {t("tariffs.pro") * t("tariffs.packageCounts.professional")}{" "}
              {t("tariffs.priceFor")} {t("tariffs.packageCounts.professional")}{" "}
              {t("tariffs.reviews")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.features.guaranteed_reviews", {
                count: t("tariffs.packageCounts.professional"),
              })}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.rating_boost")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.message_development")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.review_stats")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.competitor_analysis")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.map_point_analysis")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.crm_integration")}
            </li>
          </ul>
          <CreatePayment
            amount={179 * 110}
            currency={"UAH"}
            description={'Пакет "Professional 110"'}
          />
        </div>
      </div>
    </div>
  );

  const tariffsBodyM = (
    <Swiper
      spaceBetween={50}
      slidesPerView={1}
      navigation={{
        nextEl: ".serv-swiper-button-next",
        prevEl: ".serv-swiper-button-prev",
      }}
      pagination={{ clickable: true }}
      modules={[Navigation, Pagination]}
      className="tariffs__body tariffs__body-ua"
      style={{ padding: "0 1rem 0 1rem" }}
    >
      <SwiperSlide className="item-tariffs item-tariffs--def item-tariffs--super">
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">DEFENDER QR</h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price" style={{ color: "white" }}>
              <span>{t(`tariffs.defender.${m[defPlanSelected]}mo`)}</span>{" "}
              {t("seo.package.currency")}/{t("seo.package.month")}
            </p>
            <p className="item-tariffs__text">
              {t(`tariffs.defender.${m[defPlanSelected]}mo`) *
                m[defPlanSelected]}{" "}
              {t("tariffs.priceFor")} {m[defPlanSelected]}{" "}
              {m[defPlanSelected] == 3
                ? t("seo.package.months")
                : t("seo.package.manyMonths")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
            <div
              className="choose_container"
              style={{ marginBottom: "-25px", borderRadius: "15px" }}
            >
              <div className="button_wrapper">
                <button
                  className={`basic_choose_button ${defPlanSelected === 0 ? "selected" : ""}`}
                  onClick={() => setDefPlanSelected(0)}
                >
                  3 {t("seo.package.month")}
                </button>
                <button
                  className={`basic_choose_button ${defPlanSelected === 1 ? "selected" : ""}`}
                  onClick={() => setDefPlanSelected(1)}
                >
                  6 {t("seo.package.month")}
                </button>
                <button
                  className={`basic_choose_button ${defPlanSelected === 2 ? "selected" : ""}`}
                  onClick={() => setDefPlanSelected(2)}
                >
                  12 {t("seo.package.month")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.features.qr_filter")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.instant_email_alert")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.custom_review_page")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.review_stats")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.employee_control")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.strategy_selection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.pos_design")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.surveying")}
            </li>
          </ul>

          <CreatePayment
            amount={7860}
            currency={"UAH"}
            description={'Пакет "Defender"'}
          />
        </div>
      </SwiperSlide>
      <SwiperSlide className="item-tariffs item-tariffs--basic">
        <div className={"item-tariffs__bonus-cover"}></div>
        <div className={"item-tariffs__bonus"}>
          <p>+5 {t("tariffs.bonus_text")}</p>
        </div>
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">
            START {t("tariffs.packageCounts.start")}
          </h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price">
              <span>{t("tariffs.start")}</span> {t("tariffs.perReview")}
            </p>
            <p className="item-tariffs__text">
              {t("tariffs.start") * t("tariffs.packageCounts.start")}{" "}
              {t("tariffs.priceFor")} {t("tariffs.packageCounts.start")}{" "}
              {t("tariffs.reviews")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.features.guaranteed_reviews", {
                count: t("tariffs.packageCounts.start"),
              })}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.rating_boost")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.message_development")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.review_stats")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.competitor_analysis")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.map_point_analysis")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.crm_integration")}
            </li>
          </ul>

          <CreatePayment
            amount={2950}
            currency={"UAH"}
            description={'Пакет "Start 10"'}
          />
        </div>
      </SwiperSlide>
      <SwiperSlide className="tariffs__item item-tariffs item-tariffs--popular">
        <div className={"item-tariffs__bonus-cover"}></div>
        <div className={"item-tariffs__bonus"}>
          <p>+10 {t("tariffs.bonus_text")}</p>
        </div>
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">
            BASIC {t("tariffs.packageCounts.basic")}
          </h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price">
              <span>{t("tariffs.basic")}</span> {t("tariffs.perReview")}
            </p>
            <p className="item-tariffs__text">
              {t("tariffs.basic") * t("tariffs.packageCounts.basic")}{" "}
              {t("tariffs.priceFor")} {t("tariffs.packageCounts.basic")}{" "}
              {t("tariffs.reviews")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.features.guaranteed_reviews", {
                count: t("tariffs.packageCounts.basic"),
              })}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.rating_boost")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.message_development")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.review_stats")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.competitor_analysis")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.map_point_analysis")}
            </li>
            <li className="item-tariffs__li item-tariffs__li--disabled">
              {t("tariffs.features.crm_integration")}
            </li>
          </ul>
          <CreatePayment
            amount={189 * 50}
            currency={"UAH"}
            description={'Пакет "Basic 50"'}
          />
        </div>
      </SwiperSlide>
      <SwiperSlide className="tariffs__item item-tariffs item-tariffs--professional">
        <div className={"item-tariffs__bonus-cover"}></div>
        <div className={"item-tariffs__bonus"}>
          <p>+20 {t("tariffs.bonus_text")}</p>
        </div>
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">
            PROFESSIONAL {t("tariffs.packageCounts.professional")}
          </h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price">
              <span>{t("tariffs.pro")}</span> {t("tariffs.perReview")}
            </p>
            <p className="item-tariffs__text">
              {t("tariffs.pro") * t("tariffs.packageCounts.professional")}{" "}
              {t("tariffs.priceFor")} {t("tariffs.packageCounts.professional")}{" "}
              {t("tariffs.reviews")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.features.guaranteed_reviews", {
                count: t("tariffs.packageCounts.professional"),
              })}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.rating_boost")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.message_development")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.review_stats")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.competitor_analysis")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.map_point_analysis")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.crm_integration")}
            </li>
          </ul>
          <CreatePayment
            amount={179 * 110}
            currency={"UAH"}
            description={'Пакет "Professional 110"'}
          />
        </div>
      </SwiperSlide>
    </Swiper>
  );

  const defTariffsBody = (
    <div className="tariffs__body tariffs__body-ua">
      <div className="item-tariffs item-tariffs--def">
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">DEFENDER QR</h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price" style={{ color: "white" }}>
              <span>{t(`tariffs.defender.${m[defPlanSelected]}mo`)}</span>{" "}
              {t("seo.package.currency")}/{t("seo.package.month")}
            </p>
            <p className="item-tariffs__text">
              {t(`tariffs.defender.${m[defPlanSelected]}mo`) *
                m[defPlanSelected]}{" "}
              {t("tariffs.priceFor")} {m[defPlanSelected]}{" "}
              {m[defPlanSelected] == 3
                ? t("seo.package.months")
                : t("seo.package.manyMonths")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
            <div
              className="choose_container"
              style={{ marginBottom: "-25px", borderRadius: "15px" }}
            >
              <div className="button_wrapper">
                <button
                  className={`basic_choose_button ${defPlanSelected === 0 ? "selected" : ""}`}
                  onClick={() => setDefPlanSelected(0)}
                >
                  3 {t("seo.package.month")}
                </button>
                <button
                  className={`basic_choose_button ${defPlanSelected === 1 ? "selected" : ""}`}
                  onClick={() => setDefPlanSelected(1)}
                >
                  6 {t("seo.package.month")}
                </button>
                <button
                  className={`basic_choose_button ${defPlanSelected === 2 ? "selected" : ""}`}
                  onClick={() => setDefPlanSelected(2)}
                >
                  12 {t("seo.package.month")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.features.qr_filter")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.instant_email_alert")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.custom_review_page")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.review_stats")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.employee_control")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.strategy_selection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.pos_design")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.surveying")}
            </li>
          </ul>

          <CreatePayment
            amount={7860}
            currency={"UAH"}
            description={'Пакет "Defender"'}
          />
        </div>
      </div>
      <div className="item-tariffs item-tariffs--def item-tariffs--sms">
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">DEFENDER SMS</h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price" style={{ color: "white" }}>
              <span>1</span> {t("seo.package.currency")}/SMS
            </p>
            <p
              className="item-tariffs__text"
              style={{ color: "lightslategray" }}
            >
              {t("tariffs.299uah")} {t("tariffs.perNegativeReview")}
            </p>
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.unlimited_sms")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.surveying")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.rating_boost")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.script_development")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.review_stats")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.competitor_analysis")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.crm_integration")}
            </li>
          </ul>

          <CreatePayment
            amount={2950}
            currency={"UAH"}
            description={'Пакет "Start 10"'}
          />
        </div>
      </div>
      <div className="item-tariffs item-tariffs--def item-tariffs--super">
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">SUPER DEFENDER</h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price" style={{ color: "white" }}>
              <span>{t("tariffs.299uah")}</span> {t("tariffs.perReview")}
            </p>
            <p className="item-tariffs__text">
              {t("tariffs.299uah") * 50} {t("tariffs.priceFor")} 50{" "}
              {t("tariffs.reviews")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.growth_guarantee")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.surveying")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.rating_boost")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.message_development")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.review_stats")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.competitor_analysis")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.crm_integration")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.defender_sms")}
            </li>
          </ul>
          <CreatePayment
            amount={189 * 50}
            currency={"UAH"}
            description={'Пакет "Basic 50"'}
          />
        </div>
      </div>
    </div>
  );

  const defTariffsBodyM = (
    <Swiper
      spaceBetween={50}
      slidesPerView={1}
      navigation={{
        nextEl: ".serv-swiper-button-next",
        prevEl: ".serv-swiper-button-prev",
      }}
      pagination={{ clickable: true }}
      modules={[Navigation, Pagination]}
      className="tariffs__body tariffs__body-ua"
      style={{ padding: "0 1rem 0 1rem" }}
    >
      <SwiperSlide className="item-tariffs item-tariffs--def">
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">DEFENDER QR</h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price" style={{ color: "white" }}>
              <span>{t(`tariffs.defender.${m[defPlanSelected]}mo`)}</span>{" "}
              {t("seo.package.currency")}/{t("seo.package.month")}
            </p>
            <p className="item-tariffs__text">
              {t(`tariffs.defender.${m[defPlanSelected]}mo`) *
                m[defPlanSelected]}{" "}
              {t("tariffs.priceFor")} {m[defPlanSelected]}{" "}
              {m[defPlanSelected] == 3
                ? t("seo.package.months")
                : t("seo.package.manyMonths")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
            <div
              className="choose_container"
              style={{ marginBottom: "-25px", borderRadius: "15px" }}
            >
              <div className="button_wrapper">
                <button
                  className={`basic_choose_button ${defPlanSelected === 0 ? "selected" : ""}`}
                  onClick={() => setDefPlanSelected(0)}
                >
                  3 {t("seo.package.month")}
                </button>
                <button
                  className={`basic_choose_button ${defPlanSelected === 1 ? "selected" : ""}`}
                  onClick={() => setDefPlanSelected(1)}
                >
                  6 {t("seo.package.month")}
                </button>
                <button
                  className={`basic_choose_button ${defPlanSelected === 2 ? "selected" : ""}`}
                  onClick={() => setDefPlanSelected(2)}
                >
                  12 {t("seo.package.month")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.features.qr_filter")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.instant_email_alert")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.custom_review_page")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.review_stats")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.employee_control")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.strategy_selection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.pos_design")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.features.surveying")}
            </li>
          </ul>

          <CreatePayment
            amount={7860}
            currency={"UAH"}
            description={'Пакет "Defender"'}
          />
        </div>
      </SwiperSlide>

      <SwiperSlide className="item-tariffs item-tariffs--def item-tariffs--sms">
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">DEFENDER SMS</h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price" style={{ color: "white" }}>
              <span>1</span> {t("seo.package.currency")}/SMS
            </p>
            <p
              className="item-tariffs__text"
              style={{ color: "lightslategray" }}
            >
              {t("tariffs.299uah")} {t("tariffs.perNegativeReview")}
            </p>
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.unlimited_sms")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.surveying")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.rating_boost")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.script_development")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.review_stats")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.competitor_analysis")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.crm_integration")}
            </li>
          </ul>

          <CreatePayment
            amount={2950}
            currency={"UAH"}
            description={'Пакет "Start 10"'}
          />
        </div>
      </SwiperSlide>
      <SwiperSlide className="item-tariffs item-tariffs--def item-tariffs--super">
        <div className="item-tariffs__head">
          <h3 className="item-tariffs__title">SUPER DEFENDER</h3>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price" style={{ color: "white" }}>
              <span>299</span> {t("tariffs.perReview")}
            </p>
            <p className="item-tariffs__text">
              {299 * 50} {t("tariffs.priceFor")} 50 {t("tariffs.reviews")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">{t("tariffs.includes")}</div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.growth_guarantee")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.surveying")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.rating_boost")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.spam_protection")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.personal_manager")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.message_development")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.review_stats")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.competitor_analysis")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.crm_integration")}
            </li>
            <li className="item-tariffs__li">
              {t("tariffs.featuresDef.defender_sms")}
            </li>
          </ul>
          <CreatePayment
            amount={189 * 50}
            currency={"UAH"}
            description={'Пакет "Basic 50"'}
          />
        </div>
      </SwiperSlide>
    </Swiper>
  );

  return (
    <main className="page">
      <section
        ref={promoRef}
        className={isPromoVisible ? "promo _watcher-view" : "promo"}
        style={{ marginBottom: "0" }}
      >
        <div className="promo__container">
          <div className="promo__body">
            <div className="promo__content">
              <pre className="promo__title">
                {t("promo.title")}&nbsp;
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/a/aa/Google_Maps_icon_%282020%29.svg"
                  style={{
                    height:
                      "clamp(1.875rem, 1.3961786372rem + 2.394106814vw, 3.5rem)",
                  }}
                  alt="Google Maps Icon"
                />
              </pre>
              <div className="promo__text">
                {t("promo.payment")}
                <br />
                {t("promo.noBots")}
              </div>
              <div className="promo__buttons">
                <MenuLink
                  className={"promo__btn button"}
                  targetId={"tariffs"}
                  text={t("promo.learnMore")}
                />
                <MenuLink
                  className={"promo__contact button"}
                  targetId={"contacts"}
                  text={t("header.tryForFree")}
                />
              </div>
            </div>
            <div className="promo__presentation">
              <div
                className="promo__img"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <a href="/files/scout_video.mp4">
                  <picture>
                    <source srcSet="/files/button.gif" type="image/gif" />
                    <img
                      className="promo__phone-decor"
                      src="/files"
                      alt="gif"
                      style={{ width: "150px" }}
                    />
                  </picture>
                </a>
              </div>
            </div>
            <div className="promo__decor">
              <img src="img/promo-robot.png" alt="Image" />
            </div>
          </div>
        </div>
      </section>
      {i18n.language === "ua" && (
        <section>
          <div className={"marquee__container"}>
            <p className={"title title-center"}>{t("ourClients")}</p>
            <ClientsMarquee />
          </div>
        </section>
      )}
      <section
        ref={calcRef}
        className={isCalcVisible ? "calc _watcher-view" : "calc"}
        style={{ display: "flex", flexWrap: "wrap", margin: "50px auto" }}
      >
        <div className="calc-container" style={{ textAlign: "center" }}>
          {/*<h1 className="title" style={{ fontSize: "2em" }}>*/}
          {/*  {t("reviewsSection.title")}*/}
          {/*</h1>*/}
          <p
            className="steps__item-text"
            style={{ marginTop: "20px", fontSize: "1.4em" }}
          >
            {t("reviewsSection.statisticsIntro")}
          </p>
          <div className="progress-circle__container">
            <div className="progress-circle">
              <div className="progress-circle__inner">
                <b style={{ fontSize: "1.2em" }}>92%</b>
              </div>
            </div>
          </div>
          <p className="steps__item-text" style={{ fontSize: "1.4em" }}>
            {t("reviewsSection.statistics")}
          </p>
        </div>
        <div className="calc-container calc-plus">
          <h2
            className="title"
            style={{ fontSize: "2em", textAlign: "center" }}
          >
            {t("reviewsSection.calculationTitle")}
          </h2>
          <Formik
            initialValues={{
              currentRating: "",
              currentVotes: "",
              desiredRating: "",
            }}
            onSubmit={(values) => {
              setCalcResult(
                CalculateDesiredRating(
                  values.currentRating,
                  values.currentVotes,
                  values.desiredRating,
                ),
              );
            }}
          >
            {({ values }) => (
              <Form className="calculator">
                <label>
                  {t("reviewsSection.currentRatingLabel")}:
                  <Field
                    type="number"
                    min={0}
                    max={5}
                    step={0.01}
                    name="currentRating"
                    value={values.currentRating}
                  />
                </label>
                <label>
                  {t("reviewsSection.currentVotesLabel")}:
                  <Field
                    type="number"
                    min={0}
                    name="currentVotes"
                    value={values.currentVotes}
                  />
                </label>
                <label>
                  {t("reviewsSection.desiredRatingLabel")}:
                  <Field
                    type="number"
                    min={0}
                    max={5}
                    step={0.01}
                    name="desiredRating"
                    value={values.desiredRating}
                  />
                </label>

                <button
                  type="submit"
                  className="calculator_btn header__btn button"
                >
                  {t("reviewsSection.calculateButton")}
                </button>
                <span className="calculator_result">
                  {calcResult
                    ? calcResult !== "invalidValues"
                      ? `${t("reviewsSection.resultMessage", { rating: calcResult[0], votes: calcResult[1] })}`
                      : t("reviewsSection.invalidInput")
                    : ""}
                </span>
              </Form>
            )}
          </Formik>
        </div>
      </section>

      <section
        data-watch
        data-watch-threshold="0.5"
        ref={platformsRef}
        className={isPlatformsVisible ? "platforms _watcher-view" : "platforms"}
        id="platforms"
      >
        <div className="platforms__container">
          <div className="platforms__head">
            <h4 className="platforms__subtitle subtitle">
              {t("platformsSection.subtitle")}
            </h4>
            <h2 className="platforms__title title">
              {t("platformsSection.title")}
            </h2>
          </div>
          <div className="platforms__items">
            <div className="platforms__item">
              <img
                src="img/platforms/gmaps.webp"
                alt={t("platformsSection.altTexts.googleMaps")}
              />
            </div>
            <div className="platforms__item">
              <img
                src="img/platforms/fb.webp"
                alt={t("platformsSection.altTexts.facebook")}
              />
            </div>
            <div className="platforms__item">
              <img
                src="img/platforms/inst.webp"
                alt={t("platformsSection.altTexts.instagram")}
              />
            </div>
            {i18n.language === "ua" && (
              <div className="platforms__item">
                <img
                  src="img/platforms/viber.webp"
                  alt={t("platformsSection.altTexts.viber")}
                />
              </div>
            )}

            <div className="platforms__item">
              <img
                src="img/platforms/whatsapp.webp"
                alt={t("platformsSection.altTexts.whatsapp")}
              />
            </div>
            {i18n.language === "ua" && (
              <>
                <div className="platforms__item">
                  <img
                    src="img/platforms/telegram.webp"
                    alt={t("platformsSection.altTexts.telegram")}
                  />
                </div>
                <div className="platforms__item">
                  <img
                    src="img/platforms/hotline.webp"
                    alt={t("platformsSection.altTexts.hotline")}
                  />
                </div>
                <div className="platforms__item">
                  <img
                    src="img/platforms/rozetka.webp"
                    alt={t("platformsSection.altTexts.rozetka")}
                  />
                </div>
                <div className="platforms__item">
                  <img
                    src="img/platforms/prom.webp"
                    alt={t("platformsSection.altTexts.prom")}
                  />
                </div>
              </>
            )}
            <div className="platforms__item">
              <img
                src="img/platforms/booking.webp"
                alt={t("platformsSection.altTexts.booking")}
              />
            </div>
            <div className="platforms__item">
              <img
                src="img/platforms/tripadvisor.webp"
                alt={t("platformsSection.altTexts.tripadvisor")}
              />
            </div>
            {i18n.language === "ua" && (
              <div className="platforms__item">
                <img
                  src="img/platforms/otzyvua.webp"
                  alt={t("platformsSection.altTexts.otzyvua")}
                />
              </div>
            )}
          </div>
        </div>
      </section>

      <section
        data-watch
        data-watch-threshold="0.3"
        ref={opportunitiesRef}
        className={
          isOpportunitiesVisible
            ? "opportunities _watcher-view"
            : "opportunities"
        }
        id="opportunities"
      >
        <section
          data-watch
          data-watch-threshold="0.3"
          ref={opportunitiesRef}
          className={
            isOpportunitiesVisible
              ? "opportunities _watcher-view"
              : "opportunities"
          }
          id="opportunities"
        >
          <div className="opportunities__container">
            <div className="opportunities__head">
              <h4 className="opportunities__subtitle subtitle title-center">
                {t("opportunities.title")}
              </h4>
              <h2 className="opportunities__title title title-center">
                {t("opportunities.subtitle")}
              </h2>
            </div>
            <div className="opportunities__body">
              <div className="opportunities__card card-opportunities">
                <h3 className="card-opportunities__title">
                  {t("opportunities.cards.easyFeedback.title")}
                </h3>
                <div className="card-opportunities__text">
                  {t("opportunities.cards.easyFeedback.text")}
                </div>
                <div className="card-opportunities__img">
                  <picture>
                    <source
                      srcSet="img/opportunities/image-1.webp"
                      type="image/webp"
                    />
                    <img src="img/opportunities/image-1.png" alt="Image" />
                  </picture>
                </div>
              </div>
              <div className="opportunities__card card-opportunities">
                <h3 className="card-opportunities__title">
                  {t("opportunities.cards.negativeProtection.title")}
                </h3>
                <div className="card-opportunities__text">
                  {t("opportunities.cards.negativeProtection.text")}
                </div>
                <div className="card-opportunities__img">
                  <picture>
                    <source
                      srcSet="img/opportunities/image-2.webp"
                      type="image/webp"
                    />
                    <img src="img/opportunities/image-2.png" alt="Image" />
                  </picture>
                </div>
              </div>
              <div className="opportunities__card card-opportunities">
                <h3 className="card-opportunities__title">
                  {t("opportunities.cards.multichannelFeedback.title")}
                </h3>
                <div className="card-opportunities__text">
                  {t("opportunities.cards.multichannelFeedback.text")}
                </div>
                <div className="card-opportunities__img">
                  <picture>
                    <source
                      srcSet="img/opportunities/image-3.webp"
                      type="image/webp"
                    />
                    <img src="img/opportunities/image-3.png" alt="img3" />
                  </picture>
                </div>
              </div>
              <div className="opportunities__card card-opportunities">
                <h3 className="card-opportunities__title">
                  {t("opportunities.cards.statistics.title")}
                </h3>
                <div className="card-opportunities__text">
                  {t("opportunities.cards.statistics.text")}
                </div>
                <div className="card-opportunities__img">
                  <picture>
                    <source
                      srcSet="img/opportunities/image-4.webp"
                      type="image/webp"
                    />
                    <img src="img/opportunities/image-4.png" alt="Image" />
                  </picture>
                </div>
              </div>
              <div className="opportunities__card card-opportunities">
                <h3 className="card-opportunities__title">
                  {t("opportunities.cards.paymentForResults.title")}
                </h3>
                <div className="card-opportunities__text">
                  {t("opportunities.cards.paymentForResults.text")}
                </div>
                <div className="card-opportunities__img">
                  <picture>
                    <source
                      srcSet="img/opportunities/image-5.webp"
                      type="image/webp"
                    />
                    <img src="img/opportunities/image-5.png" alt="Image" />
                  </picture>
                </div>
              </div>
              <div className="opportunities__card card-opportunities">
                <h3 className="card-opportunities__title">
                  {t("opportunities.cards.customization.title")}
                </h3>
                <div className="card-opportunities__text">
                  {t("opportunities.cards.customization.text")}
                </div>
                <div className="card-opportunities__img">
                  <picture>
                    <source
                      srcSet="img/opportunities/image-6.webp"
                      type="image/webp"
                    />
                    <img src="img/opportunities/image-6.png" alt="Image" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <section
        data-watch
        data-watch-threshold="0.3"
        ref={optionsRef}
        className={isOptionsVisible ? "options _watcher-view" : "options"}
      >
        <div className="options__container">
          <div className="options__body">
            <div className="options__content">
              <div className="options__head">
                <h4 className="options__subtitle subtitle title-center">
                  {t("options.subtitle")}
                </h4>
                <h2 className="options__title title title-center">
                  {t("options.title")}
                </h2>
              </div>
              <ul className="options__list">
                <li className="options__item">{t("options.list.item1")}</li>
                <li className="options__item">{t("options.list.item2")}</li>
                <li className="options__item">{t("options.list.item3")}</li>
                <li className="options__item">{t("options.list.item4")}</li>
                <li className="options__item">{t("options.list.item5")}</li>
              </ul>
            </div>
            <div className="options__img">
              <picture>
                <source
                  srcSet={
                    window.location.host === "scout.com.ua"
                      ? "img/options-image.webp"
                      : "img/options-image-w.webp"
                  }
                  type="image/webp"
                />
                <img
                  src={
                    window.location.host === "scout.com.ua"
                      ? "img/options-image.png"
                      : "img/options-image-w.png"
                  }
                  alt="Image"
                />
              </picture>
            </div>
          </div>
        </div>
      </section>

      {/*<section*/}
      {/*  data-watch*/}
      {/*  data-watch-threshold="0.3"*/}
      {/*  ref={stepsRef}*/}
      {/*  className={isStepsVisible ? "steps _watcher-view" : "steps"}*/}
      {/*>*/}
      {/*  <div className="steps__container">*/}
      {/*    <div className="steps__head">*/}
      {/*      <h4 className="steps__subtitle subtitle">{t("steps.subtitle")}</h4>*/}
      {/*      <h2 className="steps__title title">{t("steps.title")}</h2>*/}
      {/*    </div>*/}
      {/*    <div className="steps__body">*/}
      {/*      <div className="steps__item">*/}
      {/*        <div className="steps__item-number">01</div>*/}
      {/*        <div className="steps__item-img">*/}
      {/*          <picture>*/}
      {/*            <source srcSet="img/steps/image-1.webp" type="image/webp" />*/}
      {/*            <img src="img/steps/image-1.png" alt="Image" />*/}
      {/*          </picture>*/}
      {/*        </div>*/}
      {/*        <div className="steps__item-text">{t("steps.item1")}</div>*/}
      {/*      </div>*/}
      {/*      <div className="steps__item">*/}
      {/*        <div className="steps__item-number">02</div>*/}
      {/*        <div className="steps__item-img">*/}
      {/*          <picture>*/}
      {/*            <source srcSet="img/steps/image-2.webp" type="image/webp" />*/}
      {/*            <img src="img/steps/image-2.png" alt="Image" />*/}
      {/*          </picture>*/}
      {/*        </div>*/}
      {/*        <div className="steps__item-text">{t("steps.item2")}</div>*/}
      {/*      </div>*/}
      {/*      <div className="steps__item">*/}
      {/*        <div className="steps__item-number">03</div>*/}
      {/*        <div className="steps__item-img">*/}
      {/*          <picture>*/}
      {/*            <source srcSet="img/steps/image-3.webp" type="image/webp" />*/}
      {/*            <img src="img/steps/image-3.png" alt="Image" />*/}
      {/*          </picture>*/}
      {/*        </div>*/}
      {/*        <div className="steps__item-text">{t("steps.item3")}</div>*/}
      {/*      </div>*/}
      {/*      <div className="steps__item">*/}
      {/*        <div className="steps__item-number">04</div>*/}
      {/*        <div className="steps__item-img">*/}
      {/*          <picture>*/}
      {/*            <source srcSet="img/steps/image-4.webp" type="image/webp" />*/}
      {/*            <img src="img/steps/image-4.png" alt="Image" />*/}
      {/*          </picture>*/}
      {/*        </div>*/}
      {/*        <div className="steps__item-text">{t("steps.item4")}</div>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</section>*/}
      <AdvantagesSection advantageSlides={advantageSlides} />
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          alignItems: "center",
          width: "100svw",
          background: "#fa9d11",
          padding: "10px",
          color: "white",
        }}
        id="tariffsTop"
      >
        <div className={"flex-lg"}>
          <p>{t("tariffs.payOnlyForRealReviews")}</p>
          <p>&nbsp;{t("tariffs.noFakeBoosts")}</p>
        </div>
        <div className={"flex-lg"}>
          <p>{t("tariffs.googleNeverDeletesReviews")}</p>
          <p>&nbsp;{t("tariffs.ratingAndSalesWillGrow")}</p>
        </div>
      </div>
      <section
        data-watch
        data-watch-threshold="0.15"
        ref={tariffsRef}
        className={isTariffsVisible ? "tariffs _watcher-view" : "tariffs"}
        id="tariffs"
      >
        <div className="tariffs__container">
          <div className="tariffs__head"></div>
          {windowWidth < 700 ? tariffsBodyM : tariffsBody}
        </div>
      </section>
      {/*{i18n.language === "ua" && (*/}
      {/*  <div*/}
      {/*    style={{*/}
      {/*      display: "flex",*/}
      {/*      flexFlow: "column",*/}
      {/*      alignItems: "center",*/}
      {/*      width: "100svw",*/}
      {/*      background: "#fa9d11",*/}
      {/*      padding: "10px",*/}
      {/*      color: "white",*/}
      {/*    }}*/}
      {/*    id="tariffsTop"*/}
      {/*  >*/}
      {/*    <div className={"flex-lg"}>*/}
      {/*      <p>{t("tariffs.payOnlyForRealReviews")}</p>*/}
      {/*      <p>&nbsp;{t("tariffs.noFakeBoosts")}</p>*/}
      {/*    </div>*/}
      {/*    <div className={"flex-lg"}>*/}
      {/*      <p>{t("tariffs.googleNeverDeletesReviews")}</p>*/}
      {/*      <p>&nbsp;{t("tariffs.ratingAndSalesWillGrow")}</p>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*)}*/}
      {i18n.language === "ua" && (
        <section
          style={{ paddingTop: "2rem" }}
          data-watch
          data-watch-threshold="0.15"
          ref={defTariffsRef}
          className={isDefTariffsVisible ? "tariffs _watcher-view" : "tariffs"}
          id="virtualTour"
        >
          <div className="tariffs__container tc2">
            <div className="laptop-wrapper">
              <iframe
                src="https://www.google.com/maps/embed?pb=!4v1756831688864!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJRHAxcTNHSEE.!2m2!1d50.38951571339361!2d30.62896134688264!3f100!4f0!5f0.7820865974627469"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
              <img
                src="/img/digital-device-mockup.png"
                alt="Laptop frame"
                className="frame"
              />
            </div>
            <div className="promo__content">
              <pre className="promo__title promo__title_vt">
                {t("virtual-tour.title")}&nbsp;
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/a/aa/Google_Maps_icon_%282020%29.svg"
                  style={{
                    height:
                      "clamp(1.875rem, 1.3961786372rem + 2.394106814vw, 3.5rem)",
                  }}
                  alt="Google Maps Icon"
                />
              </pre>
              <div
                className="promo__buttons hide-sm"
                style={{
                  justifyContent: "center",
                }}
              >
                <MenuLink
                  className={"promo__btn button"}
                  targetId={"contacts"}
                  text={t("promo.learnMore")}
                />
              </div>
            </div>
          </div>
          <div
            className="promo__buttons show-sm"
            style={{
              justifyContent: "center",
              marginTop: "1rem",
            }}
          >
            <MenuLink
              className={"promo__btn button"}
              targetId={"contacts"}
              text={t("promo.learnMore")}
            />
          </div>
        </section>
      )}
      {i18n.language === "ua" && (
        <section>
          <div className={"marquee__container"}>
            <p className={"title title-center"}>{t("ourClients")}</p>
            <ClientsMarquee forVirtualTour={true} />
          </div>
        </section>
      )}
      <section
        data-watch
        data-watch-threshold="0.5"
        ref={faqRef}
        className={isFaqVisible ? "faq _watcher-view" : "faq"}
      >
        <div className="faq__container">
          <div className="faq__body">
            <Accordion className="spollers">
              {faqs.map((faq, index) => (
                <Accordion.Item
                  className="spollers__item"
                  eventKey={index}
                  key={index}
                >
                  <Accordion.Header className="spollers__title">
                    {faq.title}
                  </Accordion.Header>
                  <Accordion.Body className="spollers__body">
                    {faq.content}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
      <section
        data-watch
        data-watch-threshold="0.5"
        ref={servicesRef}
        className={isServicesVisible ? "services _watcher-view" : "services"}
      >
        <div className="services__container">
          <div className="services__head">
            <h4 className="services__subtitle subtitle">{t("whereExactly")}</h4>
            <h2 className="services__title title">{t("weCanHelp")}</h2>
          </div>
          <div className="services__body">
            <Swiper
              spaceBetween={50}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                1200: {
                  slidesPerView: 4,
                },
              }}
              navigation={{
                nextEl: ".serv-swiper-button-next",
                prevEl: ".serv-swiper-button-prev",
              }}
              pagination={{ clickable: true }}
              modules={[Navigation, Pagination]}
              className="services__slider"
            >
              {services.map((service, index) => (
                <SwiperSlide key={index} className="item-services swiper-slide">
                  <div className="item-services__img">
                    <img
                      src={`/img/services/services-img-${index + 1}.jpg`}
                      alt={service.title}
                    />
                  </div>
                  <h4 className="item-services__title">{service.title}</h4>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="services__navigation">
              <button type="button" className="serv-swiper-button-prev">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.24408 9.41074C4.91864 9.73618 4.91864 10.2638 5.24408 10.5893L11.9107 17.2559C12.2362 17.5814 12.7638 17.5814 13.0893 17.2559C13.4147 16.9305 13.4147 16.4028 13.0893 16.0774L7.01184 10L13.0893 3.92259C13.4147 3.59715 13.4147 3.06951 13.0893 2.74408C12.7638 2.41864 12.2362 2.41864 11.9107 2.74408L5.24408 9.41074Z"
                    fill="#C4D0E4"
                  />
                </svg>
              </button>
              <button type="button" className="serv-swiper-button-next">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.7559 9.41074C15.0814 9.73618 15.0814 10.2638 14.7559 10.5893L8.08926 17.2559C7.76382 17.5814 7.23618 17.5814 6.91075 17.2559C6.58531 16.9305 6.58531 16.4028 6.91075 16.0774L12.9882 10L6.91074 3.92259C6.58531 3.59715 6.58531 3.06951 6.91074 2.74408C7.23618 2.41864 7.76382 2.41864 8.08926 2.74408L14.7559 9.41074Z"
                    fill="#C4D0E4"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      <ContactForm country={i18n.language} />
    </main>
  );
}

export default Home;
